module.exports = __webpack_public_path__ + "static/media/mastercard.da1e075c.svg";